<template>
  <span v-if="is" class="opc-cycle__current-badge">{{ $t('billing.common.billing_cycle_current') }}</span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['currentEditPlan']),
    is(){
      const isScenario = this.$context.is.modal && this.$context.is.edit;
      const isSameCategory = this.currentEditPlan?.category == this.value?.category;
      const isCurBillingCycle = this.currentEditPlan?.billing_cycle == this.value?.billing_cycle;
      return isScenario && isSameCategory && isCurBillingCycle;
    }
  }
};
</script>

<style lang="scss" scoped>
.opc-cycle__current-badge {
  color: #2057b1;
  background-color: #f2f8ff;
  border: 1px solid #a8ccf8;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  padding: 0 6px;
  line-height: 19px;
  height: 20px;
  margin-left: 6px;
}
</style>